import * as React from "react";
import { connect } from "react-redux";
import NotAuthorized from "../common/NotAuthorized";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";
import { MyChartHeading } from "../ecosystem/mybswh";

class CommunityManage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CommunityManage.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { hasMyChart, serverData, primaryUser, currentUser } = this.props;
        const { proxyName } = Tools.getProxyName(primaryUser, currentUser);
        const heading = <MyChartHeading
            heading="Community Accounts"
            description="Bring your health information together"
            proxyName={proxyName}
        />;
        return hasMyChart
            ? <MyChartContainer
                mode="communityManage"
                title="Manage Community Accounts"
                byroute="false"
                serverData={serverData}
                containerClass="personal-info-container"
                heading={heading}
            />
            : <NotAuthorized />;
    }
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        serverData: state.session.serverData,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
    };
};

export default connect(mapStateToProps)(CommunityManage);